// Trying to import the toast from the toast store here throws an error
// because PrimeVue is badly written. Instead, we must pass the toast instance.
const copyToClipboard = (toast: any, text: string) => {
  navigator.clipboard.writeText(text);

  const fakeResp = {
    data: {
      success: true,
      message: 'Copied to clipboard'
    }
  }
  toast.success(fakeResp);
}

export {
  copyToClipboard
}